import React,{useState,useEffect} from 'react'
import logo from './logo.svg';
import './App.css';
import { HashRouter,Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Auth from "./pages/auth"
import Dashboard from './pages/dashboard'
import Users from './pages/users'
import UserPoints from "./pages/userPoints"
import Reset from './pages/reset'
import Stores from './pages/stores'
import OfflineStores from './pages/offlineStores'
import Winners from './pages/winners'
import StoreDetails from './pages/storeDetails'
import AllTransactionsList from './pages/allTransactions'
import RejectedTransactionsList from './pages/rejectedTransactions'
import PendingTransactionsList from './pages/pendingTransactions'
import ApprovedTransactionsList from './pages/approvedTransactions'
import ReceiptDetails from './pages/receiptDetails'
import ReceiptData from './pages/receiptData'
import ReportGenerator from './pages/reports'

function App(){
  return(
<AuthProvider>
<div>
<HashRouter>
    <Routes>
        <Route path="/" element={<Auth/>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard/></ProtectedRoute>} />
        <Route path="/users/:userId" element={<ProtectedRoute><UserPoints /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><Users/></ProtectedRoute>} />
        <Route path="/stores/:storeId" element={<ProtectedRoute><StoreDetails/></ProtectedRoute>} />
        <Route path="/stores" element={<ProtectedRoute><Stores/></ProtectedRoute>} />
        <Route path="/offline-stores" element={<ProtectedRoute><OfflineStores/></ProtectedRoute>} />
        <Route path="/winners" element={<ProtectedRoute><Winners/></ProtectedRoute>} />
        <Route path="/all-transactions" element={<ProtectedRoute><AllTransactionsList/></ProtectedRoute>} />
        <Route path="/rejected-transactions" element={<ProtectedRoute><RejectedTransactionsList/></ProtectedRoute>} />
        <Route path="/pending-transactions" element={<ProtectedRoute><PendingTransactionsList/></ProtectedRoute>} />
        <Route path="/approved-transactions" element={<ProtectedRoute><ApprovedTransactionsList/></ProtectedRoute>} />
        <Route path="/receipt-details/:receiptId" element={<ProtectedRoute><ReceiptDetails/></ProtectedRoute>} />
        <Route path="/receipt-data/:receiptId" element={<ProtectedRoute><ReceiptData/></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><ReportGenerator/></ProtectedRoute>} />
        <Route path="/reset" element={<ProtectedRoute><Reset/></ProtectedRoute>} />
    </Routes>
    </HashRouter>
</div>
</AuthProvider>

  )
}

export default App;
